// src/utils/tokenHelper.ts
//
// Graph token acquisition with incremental consent (R-08): callers pass the
// scopes their feature needs (default: file access for SharePoint/VDR flows;
// email passes mailScopes). First use of a new scope triggers a consent popup;
// after that silent acquisition succeeds.
import { msalInstance, acquireTokenPopupOnce } from "../msalInstance";
import { uploadScopes } from "../msalConfig";
import type { AuthenticationResult, SilentRequest } from "@azure/msal-browser";

export async function getToken(scopes: string[] = uploadScopes): Promise<string> {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No user logged in");
  }

  const silentReq: SilentRequest = { scopes, account };

  try {
    const res: AuthenticationResult = await msalInstance.acquireTokenSilent(silentReq);
    return res.accessToken;
  } catch (silentErr) {
    const interactive: AuthenticationResult = await acquireTokenPopupOnce({ scopes });

    if (interactive.account) {
      msalInstance.setActiveAccount(interactive.account);
    }

    const res2: AuthenticationResult = await msalInstance.acquireTokenSilent({
      scopes,
      account: interactive.account ?? account,
    });

    if (res2.scopes?.some((s) => s.toLowerCase().startsWith("sites."))) {
      console.warn("Unexpected Sites.* scope present:", res2.scopes);
    }

    return res2.accessToken;
  }
}
